import api from "@/assets/js/api";
// const { VUE_APP_UCENTER, VUE_APP_APP } = process.env
import {
  VUE_APP_UCENTER,
  VUE_APP_APP,
  VUE_APP_ID,
  VUE_APP_KEY,
  VUE_APP_ENV,
} from "@/assets/js/stationSetting";
//持仓列表 (开仓 持仓)
export function apiGetPositionList(data = {}) {
  return api({
    url: VUE_APP_UCENTER + `/Contract/openPositionList`,
    data,
    type: "POST",
  });
}
